<template>
	<v-list-tile v-bind:key="event.uuid" @click.stop="open" :style="tile_style" :class="tile_class" v-observe-visibility="{callback: visibility_changed, once: true, intersection: {rootMargin: '1000px'}}">

		<v-list-tile-content style="min-width: 60px; max-width: 60px !important;">
    	<v-list-tile-title :class="$dark() ? 'white--text' : 'black--text'">{{event.cached_start_time | format_time}}</v-list-tile-title>
      <v-list-tile-sub-title class="grey--text" style="font-size: 11px;">{{event.cached_end_time | format_time}}</v-list-tile-sub-title>
		</v-list-tile-content>

   	<v-list-tile-content style="width: 30%;">
     	<v-list-tile-title>{{ title }}</v-list-tile-title>
     	<v-list-tile-sub-title class="grey--text text--lighten-1">
				{{subtitle}}&nbsp;
			</v-list-tile-sub-title>
		</v-list-tile-content>
		<template v-if="load_info">

		<v-list-tile-content style="width: 25%" class="hidden-xs-only">
			<channel :channel="event.event_group.channel_id" :event="event" type="source"></channel>
		</v-list-tile-content>

		<v-list-tile-content style="width: 50px" class="hidden-xs-only" v-if="$is_admin()">
			<connection-stats :channel="event.event_group.channel_id" :destchannel="event.channel_id" :event="event"></connection-stats>
		</v-list-tile-content>

		<v-list-tile-content style="width: 25%;" class="hidden-xs-only">
			<channel :channel="event.channel_id" :event="event" type="destination" ></channel>
		</v-list-tile-content>

		<v-list-tile-action @click.stop="" v-if="$is_admin()" class="hidden-xs-only">
			<todo-button :uuid="event.uuid">
			<template v-slot:off>
				<v-btn dark small flat fab><v-icon>beenhere</v-icon></v-btn>
			</template>
			<template v-slot:on>
				<v-btn dark small color="green" flat fab><v-icon>beenhere</v-icon></v-btn>
			</template>
	
			</todo-button>
		</v-list-tile-action>

		<v-list-tile-action @click.stop="" class="hidden-xs-only">
	    <v-menu offset-y :close-on-content-click="true" :nudge-width="100" v-model="preview_menu" v-if="is_current || is_future">
				<v-btn slot="activator" dark small color="deep-orange" flat fab><v-icon>live_tv</v-icon></v-btn>
				<v-list dense>
					<v-list-tile @click="open_preview_in_new_tab"><v-list-tile-title>Preview in new tab</v-list-tile-title></v-list-tile>
					<v-list-tile @click="open_live_in_new_tab"><v-list-tile-title>Live in new tab</v-list-tile-title></v-list-tile>
				</v-list>
		 </v-menu>
		</v-list-tile-action>

		<!-- Stop button -->
		<v-list-tile-action class="hidden-xs-only">
			<stop-button :uuid="event.uuid" v-if="is_current">
				<v-btn dark small color="red" flat fab><v-icon>stop</v-icon></v-btn>
			</stop-button>
		</v-list-tile-action>
		</template>
	</v-list-tile>
</template>

<script>
import datelib from '@/lib/date.js';
import strftime from 'strftime';
import Vue from 'vue';
import StopButton from '../StopEvent'
import TodoButton from '../TodoEvent'
import Channel from './Channel'
import ConnectionStats from './ConnectionStats'

import EventModel from '@/models/event.js'
import ChannelModel from '@/models/channel.js'

import VideoPlayer from '@/components/multiview/Video'

export default {
	props: ["event"],
  filters: {
  	...datelib
  },
	data () {
		return {
			preview_menu: false,
			inline_preview: false,
			preview_type: "preview",
			timestamp: 0,
			updater: undefined,
			is_past: false,
			is_todo_list: false,
			todo_list_status: undefined,
			is_current: false,
			is_future: false,
			tile_style: "",
			tile_class: "",
			load_info: false,
			subtitle: "",
		}
	},
	components: {
		StopButton,
		Channel,
		VideoPlayer,
		ConnectionStats,
		TodoButton
	},
	mounted () {
		var self = this;
		this.timestamp = self.$store.state.timestamp;
		this.timestamp_update();

		this.updater = setInterval(function() {
			self.timestamp = self.$store.state.timestamp;
			self.timestamp_update();
		},1000);
		EventModel.subtitle_cb(this.event, "", function(val) {
			self.subtitle = val;
		})
	},
	beforeDestroy() {
		if (typeof(this.updater) != "undefined") {
			clearInterval(this.updater);
		}
	},
	computed: {
		title () {
      return EventModel.title(this.event);
		},
/*		subtitle () {
			return EventModel.subtitle(this.event);
		},*/
    duration() {
      return EventModel.duration_text(this.event);
    },
    live_url() {
    	return EventModel.live_url(this.event);
    },
    preview_url() {
    	return EventModel.preview_url(this.event);
    },
    inline_url() {
    	if (this.preview_type == "preview") return this.preview_url
    	return this.live_url;
    }

	},
	methods: {
		toggle_todo () {

		},
		visibility_changed (newVal) {
			this.load_info = newVal;
		},
		timestamp_update() {
			this.is_current = EventModel.is_current(this.event, this.timestamp);
			this.is_past = EventModel.is_past(this.event, this.timestamp);
			this.is_future = EventModel.is_future(this.event, this.timestamp);
			this.is_todo_list = this.get_is_todo_list();

			if (this.is_todo_list == true) {
				this.todo_list_status = this.get_todo_list_status();
			} else {
				this.todo_list_status = undefined;
			}
			this.tile_style = this.get_tile_style();
		},
		get_tile_style () {
			var ret = "";
			if (this.is_past) ret = ret + "opacity: 0.4;";
			if (this.inline_preview == true) ret = ret + "height: 127px;";

			if (this.is_todo_list == true) {
				if (this.todo_list_status == "watch") {
					if (this.is_past == true) {
						ret = ret + "background-color: #B71C1C88;";
					} else {
						ret = ret + "background-color: #263238AA;";
					}
				}
				if (this.todo_list_status == "ready") ret = ret + "background-color: #1B5E2088;";
			}

			return ret;
		},
		get_is_todo_list () {
			return EventModel.is_todo_list(this.event, this.$store.state.account);
		},
		get_todo_list_status () {
			return EventModel.todo_list_status(this.event, this.$store.state.account);
		},
    open () {
    	this.$router.push("/dashboard/event/"+this.event.uuid)
    },
    open_preview_in_new_tab () {
    	window.open(this.preview_url);
    },
    open_live_in_new_tab() {
    	window.open(this.live_url);
    },
    open_inline_preview() {
    	this.preview_type = "preview";
    	this.inline_preview = true;
    },
    open_inline_live() {
    	this.preview_type = "live";
    	this.inline_preview = true;
    },
    close_inline_preview() {
    	this.inline_preview = false;
    },
    open_channel (channel_id) {
      var ch = ChannelModel.channel_by_id(channel_id);
      if (typeof(ch) != "undefined") {
        this.$router.push("/dashboard/channel/" + ch.uuid );
      }
    },
   	open_instance (channel_id) {
      var instance = ChannelModel.instance(channel_id, this.event);
      if (typeof(instance) != "undefined") {
        this.open_instance_by_id(instance.id);
      }
    },
    open_instance_by_id (instance_id) {
      this.$router.push("/dashboard/instance/" + instance_id);
    },
	}
}
</script>
